module.exports = __webpack_public_path__ + "img/download-icon-white.a960ba9c.svg";